import React, { useEffect, useState } from "react";
import SettlementFormModal from "./SettlementFormModal";

const EditSettlementButton = ({
  columnData,
  updateAtmedSettlementsLabDiagnostics,
  getAllAtmedSettlementsLabDiagnostics,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(false);
  const [settlementURL, setSettlementURL] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    const payloadObj = {
      id: columnData.id,
      payload: { lab_order: data },
    };
    hideModal();
    await updateAtmedSettlementsLabDiagnostics(payloadObj);
  };

  useEffect(() => {
    setFormData(columnData);
  }, [modalVisible]);

  return (
    <>
      <SettlementFormModal
        data={formData}
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        setSettlementURL={(e) => setSettlementURL(e)}
        settlementURL={settlementURL}
        title={`Update Settlement Status - ${columnData.orderid}`}
        keyName={"lab_order"}
        updateAtmedSettlementsLabDiagnostics={
          updateAtmedSettlementsLabDiagnostics
        }
        getAllAtmedSettlementsLabDiagnostics={
          getAllAtmedSettlementsLabDiagnostics
        }
        id={columnData.id}
        submitText="Update"
      />
      <div onClick={showModal}> Edit Status</div>
    </>
  );
};
export default EditSettlementButton;
